import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  container: {
    width: '100%',
  },
  wrapper: {
    display: 'grid',
    gridTemplateColumns: '180px 185px 1fr 1fr',
    gap: '16px',
    width: '100%',
  },
  label: {
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingBottom: '10px',
    color: Theme.Colors.Grayscale.SixtyFour,
    fontSize: spacing(14),
  },
  errorMessage: {
    color: Theme.Colors.Red.Base,
    marginTop: spacing(8),
    fontSize: spacing(10.5),
    fontFamily: 'Roboto',
    height: spacing(10),
    display: 'flex !important',
  },
  required: {
    color: Theme.Colors.Red.Base,
    marginLeft: spacing(4),
  },
  radioGroupStyles: {
    gap: '24px',
  },
  labelInputRadioButton: {
    marginLeft: '0px',
    marginRight: '0px',
    gap: '6px',
  },
  input: {
    '& .MuiInputBase-root': {
      fontSize: '1.4rem',
      padding: '8px 10px',
    },
  },
  textArea: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: spacing(60),
    paddingLeft: spacing(12),
    gap: spacing(16),
  },
}))
